module.exports = __webpack_public_path__ + "static/media/pick-up.506b1cea.svg";